/**
 * Where platen size rules are edited, and whether this org can get there.
 *
 * The rules live in Production settings. `ProductionAccessGuard` sends an org
 * that runs no floor of its own (a 3PL client) to /orders, so for that org a
 * link to the rules is a dead end: its 3PL sets them on its behalf. This reads
 * the guard's own signal (`useOrgRoleSurfaces().hidesProduction`), which stays
 * false until the server has answered, so an org that runs a floor never loses
 * the link on a loading blip. Surfaces that would link there show
 * `platen.rulesSetBy3pl` instead.
 *
 * The read is PASSIVE: it never refetches (or retries) on mount. It runs on
 * every expanded product row and every upload cell, and the sidebar already
 * holds this answer, so expanding a product must cost no request. The
 * sidebar and the guard keep their own observers, which still refresh a
 * stale answer when they mount.
 */
import { useOrgRoleSurfaces } from '@/hooks/useOrgRoleSurfaces';

export const PLATEN_SETTINGS_HREF = '/production/settings?area=printing#platen-size';

/** Round 4 (R4-6): each platen's pixels and Made from Large preset (86-31's section). */
export const PLATEN_VARIANTS_HREF = '/production/settings?area=printing#platen-variants';

export function useCanOpenPlatenSettings(): boolean {
  return !useOrgRoleSurfaces({ refetchOnMount: false, retryOnMount: false }).hidesProduction;
}
